import {
  V1CloudEventsAccessSummaryResponse,
  V1CloudEventsActivityAccessItem,
  V1CloudEventsActivityGroupBucket,
  V1CloudEventsActivityGroup,
  V1CloudEventsActivityGraphResponse,
  V1CloudEventsBucketPathSuggestionsResponse,
  V1CloudEventsPathSuggestion,
  V1CloudEventsResourceEvent,
  V1CloudEventsResourceHourRow,
  V1CloudEventsResourceRow,
  V1CloudEventsResourceSummaryResponse,
  V1CloudEventsSummaryResponse,
  V1DownloadCloudEventsActivityAccessResponse,
  V1ListCloudEventsResourceIdentitiesResponse,
} from '@ariksa/audittrail/api';
import {
  CanAccessResourceSummaryCounts,
  LabelResponse,
  ResourceInfo,
  RiskContextResponse,
  TagsRead,
} from '@ariksa/inventory-core/api';
import { IPagedQueryState } from 'services/utils/PagedQueryState';
import { IQueryState } from 'services/utils/QueryState';

export type CloudEventsSummaryResponse =
  | V1CloudEventsSummaryResponse
  | V1CloudEventsResourceSummaryResponse
  | V1CloudEventsAccessSummaryResponse;

export type CloudEventsSummaryState = IQueryState<CloudEventsSummaryResponse>;
export type CloudEventsActivityGraphState = IQueryState<V1CloudEventsActivityGraphResponse>;
export type CloudEventsActivityResourcesState = IQueryState<ResourceInfo[]>;
export type CloudEventsResourceIdentitiesState = IQueryState<V1ListCloudEventsResourceIdentitiesResponse>;
export type CloudEventsActivityObjectPathsState = IQueryState<V1CloudEventsBucketPathSuggestionsResponse>;
export type CloudEventsActivityGroup = V1CloudEventsActivityGroup;

export interface CloudEventsSummaryChartProps {
  summary: CloudEventsSummaryState;
  isHourly?: boolean;
  summaryPeriod?: string;
}

export interface IncidentResponseState {
  activityGroups: IPagedQueryState<V1CloudEventsActivityGroup[]>;
  activityGroup: IQueryState<V1CloudEventsActivityGroup>;
  activityGroupBuckets: IQueryState<V1CloudEventsActivityGroupBucket[]>;
  activityGroupBucketsByArn: Record<string, V1CloudEventsActivityGroupBucket>;
  activityGroupAction: IQueryState<any>;
  accessSummaryCounts: IQueryState<CanAccessResourceSummaryCounts[]>;
  activityGraph: CloudEventsActivityGraphState;
  activityObjectPaths: CloudEventsActivityObjectPathsState;
  activityBucketContexts: IQueryState<TagsRead[]>;
  activityAccesses: IPagedQueryState<V1CloudEventsActivityAccessItem[]>;
  activityIdentityCount: IQueryState<number>;
  // Tracks the activity-accesses CSV export so the download button can show a spinner.
  activityAccessesDownload: IQueryState<V1DownloadCloudEventsActivityAccessResponse>;
  objectPathsByBucket: Record<string, V1CloudEventsPathSuggestion[]>;
  activityResources: CloudEventsActivityResourcesState;
  resourceIdentities: CloudEventsResourceIdentitiesState;
  labels: IQueryState<LabelResponse[]>;
  riskContext: IQueryState<Record<string, RiskContextResponse[]>>;
  resourceRiskContext: IQueryState<Record<string, RiskContextResponse[]>>;
  resources: IPagedQueryState<V1CloudEventsResourceRow[]>;
  resourceEvents: IPagedQueryState<V1CloudEventsResourceEvent[]>;
  aggregateResourceEvents: IQueryState<V1CloudEventsResourceHourRow[]>;
  cloudEventsSummary: IQueryState<V1CloudEventsSummaryResponse>;
  resourceSummary: IQueryState<V1CloudEventsResourceSummaryResponse>;
  accessSummary: IQueryState<V1CloudEventsAccessSummaryResponse>;
}

export type ContainerState = IncidentResponseState;

export const CloudEventsViewByTabs = {
  Data: 'Data',
  Identity: 'Identity',
  Network: 'Network',
};
